import PropTypes from "prop-types"
import React, { useState } from "react"

import Box from "@material-ui/core/Box"
import Button from "@material-ui/core/Button"
import Card from "@material-ui/core/Card"
import CardActions from "@material-ui/core/CardActions"
import CardContent from "@material-ui/core/CardContent"
import CardMedia from "@material-ui/core/CardMedia"
import Container from "@material-ui/core/Container"
import Dialog from "@material-ui/core/Dialog"
import DialogActions from "@material-ui/core/DialogActions"
import DialogContent from "@material-ui/core/DialogContent"
import DialogTitle from "@material-ui/core/DialogTitle"
import Grid from "@material-ui/core/Grid"
import Typography from "@material-ui/core/Typography"

import ArrowRightAltIcon from "@material-ui/icons/ArrowRightAlt"
import FormatQuoteIcon from "@material-ui/icons/FormatQuote"

import { makeStyles } from "@material-ui/core/styles"

const useStyles = makeStyles((theme) => ({
  button: {
    color: "#77b9b2",
    paddingBottom: 7,
    paddingLeft: 10,
    paddingRight: 10,
    paddingTop: 7,
    textTransform: "uppercase",
  },
  closebutton: {
    color: "rgba(0, 0, 0, 0.3)",
    textTransform: "uppercase",
  },
  card: {
    alignItems: "start",
    // border: "1px solid rgba(0, 0, 0, 0.08)",
    borderRadius: 8,
    boxShadow: "none",
    // boxShadow: "0px 4px 12px rgba(184, 184, 184, 0.25)",
    display: "flex",
    flexDirection: "column",
    gap: 16,
    height: 388,
    justifyContent: "start",
    padding: 0,
  },
  cardActions: {
    gap: 2,
    justifyContent: "start",
    padding: 0,
  },
  cardColumn: {
    display: "flex",
    flexDirection: "column",
    gap: 12,
    width: "100%",
  },
  cardContent: {
    display: "flex",
    flex: 1,
    flexDirection: "column",
    gap: 6,
    paddingTop: 0,
  },
  cardGrid: {
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
  cardMedia: {
    border: "1px solid rgba(0, 0, 0, 0.08)",
    borderRadius: 8,
    minHeight: 140,
    width: "100%",
  },
  cardText: {
    color: "rgba(0, 0, 0, 0.5)",
    flex: 1,
    fontSize: 14,
  },
  cardSubtitle: {
    color: "rgba(0, 0, 0, 0.8)",
    fontSize: 13,
    fontWeight: 700,
    letterSpacing: 1.1,
    lineHeight: 1.1,
    textTransform: "uppercase",
  },
  cardSubtitleContainer: {
    alignItems: "end",
    display: "flex",
    minHeight: 64,
  },
  cardTitle: {
    color: "rgba(0, 0, 0, 0.7)",
    fontWeight: 700,
    fontSize: 18,
  },
  dialogContent: {
    backgroundColor: "rgba(0, 0, 0, 0.02)",
    border: "1px solid rgba(0, 0, 0, 0.08)",
    borderRadius: 4,
    fontSize: 14,
    fontWeight: 300,
    padding: 4,
    whiteSpace: "pre-wrap",
  },
  /* Override the CardMedia 
    Styles applied to the root element. */
  root: {
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "contain",
    display: "block",
  },
}))

const BIBFILE = {
  falcon: `
@article{wu2023falcon,
    title={Falcon: A Privacy-Preserving and Interpretable Vertical Federated Learning System},
    author={Wu, Yuncheng and Xing, Naili and Chen, Gang and Dinh, Tien Tuan Anh and Luo, Zhaojing and Ooi, Beng Chin and Xiao, Xiaokui and Zhang, Meihui},
    journal={Proceedings of the VLDB Endowment},
    volume={16},
    number={10},
    pages={2471--2484},
    year={2023}
  }
  
@article{wang2023incentive,
    title={Incentive-Aware Decentralized Data Collaboration},
    author={Wang, Yatong and Wu, Yuncheng and Chen, Xincheng and Feng, Gang and Ooi, Beng Chin},
    journal={Proceedings of the ACM on Management of Data},
    volume={1},
    number={2},
    pages={1--27},
    year={2023}
  }
  
@article{wu2020privacy,
    title = {Privacy Preserving Vertical Federated Learning for Tree-Based Models},
    author = {Wu, Yuncheng and Cai, Shaofeng and Xiao, Xiaokui and Chen, Gang and Ooi, Beng Chin},
    journal={Proceedings of the VLDB Endowment},
    volume = {13},
    number = {12},
    pages = {2090–2103},
    year = {2020}
  }
  `,
  gemini: `
@article{zheng2022dyhealth,
    title={DyHealth: making neural networks dynamic for effective healthcare analytics},
    author={Zheng, Kaiping and Cai, Shaofeng and Chua, Horng Ruey and Herschel, Melanie and Zhang, Meihui and Ooi, Beng Chin},
    journal={Proceedings of the VLDB Endowment},
    volume={15},
    number={12},
    pages={3445--3458},
    year={2022}
  }
  
@inproceedings{luo2021mlcask,
    title={MLCask: Efficient management of component evolution in collaborative data analytics pipelines},
    author={Luo, Zhaojing and Yeung, Sai Ho and Zhang, Meihui and Zheng, Kaiping and Zhu, Lei and Chen, Gang and Fan, Feiyi and Lin, Qian and Ngiam, Kee Yuan and Ooi, Beng Chin},
    booktitle={2021 IEEE 37th International Conference on Data Engineering},
    pages={1655--1666},
    year={2021}
  }
  
@inproceedings{zheng2020tracer,
    title={Tracer: A framework for facilitating accurate and interpretable analytics for high stakes applications},
    author={Zheng, Kaiping and Cai, Shaofeng and Chua, Horng Ruey and Wang, Wei and Ngiam, Kee Yuan and Ooi, Beng Chin},
    booktitle={Proceedings of the 2020 International Conference on Management of Data},
    pages={1747--1763},
    year={2020}
  }
  
@inproceedings{dai2018fine,
    title={Fine-grained concept linking using neural networks in healthcare},
    author={Dai, Jian and Zhang, Meihui and Chen, Gang and Fan, Ju and Ngiam, Kee Yuan and Ooi, Beng Chin},
    booktitle={Proceedings of the 2018 International Conference on Management of Data},
    pages={51--66},
    year={2018}
  }
  
@inproceedings{luo2018adaptive,
    title={Adaptive lightweight regularization tool for complex analytics},
    author={Luo, Zhaojing and Cai, Shaofeng and Gao, Jinyang and Zhang, Meihui and Ngiam, Kee Yuan and Chen, Gang and Lee, Wang-Chien},
    booktitle={2018 IEEE 34th International Conference on Data Engineering},
    pages={485--496},
    year={2018}
  }
  
@article{lee2017big,
    title={Big healthcare data analytics: Challenges and applications},
    author={Lee, Chonho and Luo, Zhaojing and Ngiam, Kee Yuan and Zhang, Meihui and Zheng, Kaiping and Chen, Gang and Ooi, Beng Chin and Yip, Wei Luen James},
    journal={Handbook of large-scale distributed computing in smart healthcare},
    pages={11--41},
    year={2017},
    publisher={Springer}
  }
  
@article{ling2014gemini,
    title={GEMINI: An integrative healthcare analytics system},
    author={Ling, Zheng Jye and Tran, Quoc Trung and Fan, Ju and Koh, Gerald CH and Nguyen, Thi and Tan, Chuen Seng and Yip, James WL and Zhang, Meihui},
    journal={Proceedings of the VLDB Endowment},
    volume={7},
    number={13},
    pages={1766--1771},
    year={2014}
  }
  `,
  armor: `
@inproceedings{cai2021arm,
    title={Arm-net: Adaptive relation modeling network for structured data},
    author={Cai, Shaofeng and Zheng, Kaiping and Chen, Gang and Jagadish, HV and Ooi, Beng Chin and Zhang, Meihui},
    booktitle={Proceedings of the 2021 International Conference on Management of Data},
    pages={207--220},
    year={2021}
  }
  
@article{luo2023regularized,
    title={Regularized Pairwise Relationship based Analytics for Structured Data},
    author={Luo, Zhaojing and Cai, Shaofeng and Wang, Yatong and Ooi, Beng Chin},
    journal={Proceedings of the ACM on Management of Data},
    volume={1},
    number={1},
    pages={1--27},
    year={2023}
  }
  `,
  fabricsharp: `
@inproceedings{ruan2021blockchains,
    title={Blockchains vs. distributed databases: Dichotomy and fusion},
    author={Ruan, Pingcheng and Dinh, Tien Tuan Anh and Loghin, Dumitrel and Zhang, Meihui and Chen, Gang and Lin, Qian and Ooi, Beng Chin},
    booktitle={Proceedings of the 2021 International Conference on Management of Data},
    pages={1504--1517},
    year={2021}
  }
  
@inproceedings{ruan2020transactional,
    title={A transactional perspective on execute-order-validate blockchains},
    author={Ruan, Pingcheng and Loghin, Dumitrel and Ta, Quang-Trung and Zhang, Meihui and Chen, Gang and Ooi, Beng Chin},
    booktitle={Proceedings of the 2020 International Conference on Management of Data},
    pages={543--557},
    year={2020}
  }
  
@inproceedings{dang2019towards,
    title={Towards scaling blockchain systems via sharding},
    author={Dang, Hung and Dinh, Tien Tuan Anh and Loghin, Dumitrel and Chang, Ee-Chien and Lin, Qian and Ooi, Beng Chin},
    booktitle={Proceedings of the 2019 International Conference on Management of Data},
    pages={123--140},
    year={2019}
  }
  
@article{ruan2019fine,
    title={Fine-grained, secure and efficient data provenance on blockchain systems},
    author={Ruan, Pingcheng and Chen, Gang and Dinh, Tien Tuan Anh and Lin, Qian and Ooi, Beng Chin and Zhang, Meihui},
    journal={Proceedings of the VLDB Endowment},
    volume={12},
    number={9},
    pages={975--988},
    year={2019}
  }
  `,
  forkbase: `
@article{wang2018forkbase,
    title = {Forkbase: An Efficient Storage Engine for Blockchain and Forkable Applications},
    author = {Wang, Sheng and Dinh, Tien Tuan Anh and Lin, Qian and Xie, Zhongle and Zhang, Meihui and Cai, Qingchao and Chen, Gang and Ooi, Beng Chin and Ruan, Pingcheng},
    journal={Proceedings of the VLDB Endowment},
    volume = {11},
    number = {10},
    pages = {1137–1150},
    year = {2018}
  }
  
@inproceedings{lin2020forkbase,
    title={Forkbase: Immutable, tamper-evident storage substrate for branchable applications},
    author={Lin, Qian and Yang, Kaiyuan and Dinh, Tien Tuan Anh and Cai, Qingchao and Chen, Gang and Ooi, Beng Chin and Ruan, Pingcheng and Wang, Sheng and Xie, Zhongle and Zhang, Meihui and others},
    booktitle={2020 IEEE 36th International Conference on Data Engineering},
    pages={1718--1721},
    year={2020}
  }
  `,
  singa: `
@inproceedings{ooi2015singa,
    title={SINGA: A distributed deep learning platform},
    author={Ooi, Beng Chin and Tan, Kian-Lee and Wang, Sheng and Wang, Wei and Cai, Qingchao and Chen, Gang and Gao, Jinyang and Luo, Zhaojing and Tung, Anthony KH and Wang, Yuan and others},
    booktitle={Proceedings of the 23rd ACM international conference on Multimedia},
    pages={685--688},
    year={2015}
  }
  
@inproceedings{wang2015singa,
    title={SINGA: Putting deep learning in the hands of multimedia users},
    author={Wang, Wei and Chen, Gang and Dinh, Anh Tien Tuan and Gao, Jinyang and Ooi, Beng Chin and Tan, Kian-Lee and Wang, Sheng},
    booktitle={Proceedings of the 23rd ACM international conference on Multimedia},
    pages={25--34},
    year={2015}
  }
  
@article{wang2016deep,
    title = {Deep Learning at Scale and at Ease},
    author = {Wang, Wei and Chen, Gang and Chen, Haibo and Dinh, Tien Tuan Anh and Gao, Jinyang and Ooi, Beng Chin and Tan, Kian-Lee and Wang, Sheng and Zhang, Meihui},
    journal = {ACM Transactions on Multimedia Computing, Communications, and Applications},
    volume = {12},
    number = {4s},
    year = {2016},
  }
  `,
  cohort: `
@inproceedings{cai2022elda,
    title={ELDA: Learning Explicit Dual-Interactions for Healthcare Analytics},
    author={Cai, Qingpeng and Zheng, Kaiping and Ooi, Beng Chin and Wang, Wei and Yao, Chang},
    booktitle={2022 IEEE 38th International Conference on Data Engineering},
    pages={393--406},
    year={2022}
  }
  
@inproceedings{xie2020cool,
    title={Cool, a COhort OnLine analytical processing system},
    author={Xie, Zhongle and Ying, Hongbin and Yue, Cong and Zhang, Meihui and Chen, Gang and Ooi, Beng Chin},
    booktitle={2020 IEEE 36th International Conference on Data Engineering},
    pages={577--588},
    year={2020}
  }
  
@article{cai2018effective,
    title={Effective temporal dependence discovery in time series data},
    author={Cai, Qingchao and Xie, Zhongle and Zhang, Meihui and Chen, Gang and Jagadish, HV and Ooi, Beng Chin},
    journal={Proceedings of the VLDB Endowment},
    volume={11},
    number={8},
    pages={893--905},
    year={2018}
  }

@inproceedings{xie2018cohort,
    title={Cohort analysis with ease},
    author={Xie, Zhongle and Cai, Qingchao and He, Fei and Ooi, Gene Yan and Huang, Weilong and Ooi, Beng Chin},
    booktitle={Proceedings of the 2018 International Conference on Management of Data},
    pages={1737--1740},
    year={2018}
  }
  
@article{jiang2016cohort,
    title = {Cohort Query Processing},
    author = {Jiang, Dawei and Cai, Qingchao and Chen, Gang and Jagadish, H. V. and Ooi, Beng Chin and Tan, Kian-Lee and Tung, Anthony K. H.},
    journal={Proceedings of the VLDB Endowment},
    volume = {10},
    number = {1},
    pages = {1–12},
    year = {2016}
  }
  `,
  foodlg: `
@misc{zheng2023plate,
    title={From Plate to Prevention: A Dietary Nutrient-aided Platform for Health Promotion in Singapore}, 
    author={Kaiping Zheng and Thao Nguyen and Jesslyn Hwei Sing Chong and Charlene Enhui Goh and Melanie Herschel and Hee Hoon Lee and Changshuo Liu and Beng Chin Ooi and Wei Wang and James Yip},
    year={2023},
    eprint={2301.03829},
    archivePrefix={arXiv},
    primaryClass={cs.LG}
 }
 
@inproceedings{zheng2022edental,
   title={eDental: Managing Your Dental Care in Diet Diaries},
   author={Zheng, Kaiping and Nguyen, Thao and Liu, Changshuo and Goh, Charlene Enhui and Ooi, Beng Chin},
   booktitle={Proceedings of the 31st ACM International Conference on Information \& Knowledge Management},
   pages={5059--5063},
   year={2022}
 }
 `,
}

const INIT_DATA = {
  current: undefined,
  isOpen: false,
}

const ItemList = ({ data, images, group }) => {
  const classes = useStyles()

  const [citeDialog, setCiteDialog] = useState(INIT_DATA)
  const [citeData, setCiteData] = useState(undefined)
  const [isCopied, setIsCopied] = useState(false)

  const findMatchingProfile = (pic_filename, allPicFiles = images) => {
    const matchedNode = allPicFiles.find(
      ({ node }) => node.childImageSharp.fixed.originalName === pic_filename
    )

    return matchedNode.node.childImageSharp.fixed.src
  }

  const handleOnClickCite = (ele) => () => {
    const obj = {
      current: ele.bibtex,
      isOpen: true,
    }
    setCiteDialog(obj)
    setCiteData(ele.bibtex)
  }

  const handleCopyCite = () => {
    setIsCopied(true)
    navigator.clipboard.writeText(BIBFILE[citeData])

    setTimeout(() => {
      setIsCopied(false)
    }, 2000)
  }

  const handleCloseCiteDialog = () => {
    setCiteDialog(INIT_DATA)
    setCiteData(undefined)
  }

  return (
    <Container className={classes.cardGrid} maxWidth="lg">
      <Grid container justifyContent="flex-start" spacing={8}>
        {data.map(
          (ele, index) =>
            ele.group === group && (
              <Grid item key={index} xs={12} sm={6} md={4}>
                <Card className={classes.card}>
                  <Box className={classes.cardColumn}>
                    <Box className={classes.cardSubtitleContainer}>
                      <Typography align="left" className={classes.cardSubtitle}>
                        {ele.subtitle}
                      </Typography>
                    </Box>

                    {/* <Divider className={classes.divider} /> */}

                    <CardMedia
                      classes={{
                        root: classes.root,
                      }}
                      className={classes.cardMedia}
                      image={findMatchingProfile(ele.pic_filename)}
                      title={ele.title}
                    />
                  </Box>

                  <CardContent className={classes.cardContent}>
                    {/* <Typography align="start" className={classes.cardSubtitle}>
                      {ele.subtitle}
                    </Typography> */}

                    <Typography
                      align="left"
                      className={classes.cardTitle}
                      component="div"
                    >
                      {ele.title}
                    </Typography>

                    <Typography align="left" className={classes.cardText}>
                      {ele.note}
                    </Typography>

                    <CardActions className={classes.cardActions}>
                      <Button
                        className={classes.button}
                        size="small"
                        onClick={handleOnClickCite(ele)}
                      >
                        Cite
                        <FormatQuoteIcon />
                      </Button>

                      <a
                        href={ele.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ textDecoration: "none" }}
                      >
                        <Button className={classes.button} size="small">
                          Learn More
                          <ArrowRightAltIcon />
                        </Button>
                      </a>
                    </CardActions>
                  </CardContent>
                </Card>
              </Grid>
            )
        )}
      </Grid>

      {citeDialog.isOpen && citeData === citeDialog.current && (
        <Dialog open={citeDialog.isOpen} onClose={handleCloseCiteDialog}>
          <DialogTitle id="export-cite">{"BibTeX Citation"}</DialogTitle>

          <DialogContent>
            <Box className={classes.dialogContent}>{BIBFILE[citeData]}</Box>
          </DialogContent>

          <DialogActions>
            <Button
              className={classes.button}
              disabled={isCopied}
              onClick={handleCopyCite}
              size="small"
            >
              {isCopied ? "Copied" : "Copy"}
            </Button>
            <Button
              className={classes.closebutton}
              onClick={handleCloseCiteDialog}
              size="small"
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </Container>
  )
}

ItemList.propTypes = {
  data: PropTypes.array.isRequired,
  images: PropTypes.array.isRequired,
}

export default ItemList
